import {deleteSupplierOffer} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierOfferKeys, supplierOfferMutationKeys} from "../../../supplierOffer-keys";
import type {SupplierOfferIdentity, SupplierOfferList} from "../../../types/supplierOffers.types";

export function deleteSupplierOfferMutationOptions() {
  const lists = {queryKey: supplierOfferKeys.lists()};
  return mutationOptions({
    mutationKey: supplierOfferMutationKeys.deleteSupplierOffer,
    mutationFn: (identity: SupplierOfferIdentity) => {
      const args: Parameters<typeof deleteSupplierOffer> = [
        identity.supplierId,
        identity.catalogItemId,
      ];
      return deleteSupplierOffer(...args);
    },
    onMutate: async (identity, {client}) => {
      await client.cancelQueries(lists);
      const previousLists = client.getQueriesData<SupplierOfferList>(lists);
      for (const [key, list] of previousLists) {
        const params = key[2];
        if (
          !list ||
          typeof params !== "object" ||
          params === null ||
          !("state" in params) ||
          params.state !== "ACTIVE"
        )
          continue;
        const items = list.items.filter(
          (item) =>
            item.supplierId !== identity.supplierId ||
            item.catalogItemId !== identity.catalogItemId,
        );
        const removed = list.items.length - items.length;
        if (removed)
          client.setQueryData<SupplierOfferList>(key, {
            ...list,
            items,
            meta: {...list.meta, total: Math.max(0, list.meta.total - removed)},
          });
      }
      return {previousLists};
    },
    onError: (_error, _identity, context, {client}) => {
      for (const [key, snapshot] of context?.previousLists ?? [])
        client.setQueryData(key, snapshot);
    },
    onSuccess: async (_result, identity, _context, {client}) => {
      client.removeQueries({queryKey: supplierOfferKeys.detail(identity)});
      await client.invalidateQueries(lists);
    },
  });
}
